<router-outlet></router-outlet>
<app-floating-chatbot></app-floating-chatbot>
